import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";
import { useLanguage } from "../i18n/LanguageContext";

const FeatureRoute = ({ feature, title = "Package Feature", description, children }) => {
  const { t } = useLanguage();
  const [access, setAccess] = useState(null);

  useEffect(() => {
    let cancelled = false;

    apiClient.get(`/features/${feature}/access`)
      .then(({ data }) => {
        if (!cancelled) setAccess(Boolean(data.has_access));
      })
      .catch(() => {
        if (!cancelled) setAccess(false);
      });

    return () => {
      cancelled = true;
    };
  }, [feature]);

  if (access === null) {
    return (
      <div className="hpa-feature-state">
        <i className="fa-solid fa-spinner fa-spin" aria-hidden="true" />
        <p>{t("Checking your package access…")}</p>
      </div>
    );
  }

  if (!access) {
    return (
      <div className="hpa-feature-state hpa-feature-locked">
        <div className="hpa-feature-lock-icon">
          <i className="fa-solid fa-lock" aria-hidden="true" />
        </div>
        <span>{t("Package feature")}</span>
        <h2>{t(title)}</h2>
        <p>
          {description ? t(description) : t("This feature is available only with eligible packages. Choose an eligible package or ask the academy team to add it to your subscription.")}
        </p>
        <Link to="/libraries" className="btn btn-primary btn-skew">
          <span>{t("Explore Eligible Packages")}</span>
        </Link>
      </div>
    );
  }

  return children;
};

export default FeatureRoute;
